"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const H2 = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M14 5h-3v6H6V5H3v14h3v-6h5v6h3V5zm5.31 6.12a.92.92 0 01.24.66 1.36 1.36 0 01-.25.77 9.499 9.499 0 01-.87 1L15 17v2h8v-2.58h-4.42l1.61-1.61c.46-.42.78-.75 1-1a4.28 4.28 0 00.63-1 2.87 2.87 0 00-.65-3.38 3.71 3.71 0 00-2.51-.83 3.54 3.54 0 00-2.55.93A3.6 3.6 0 0015 11.88h2.67a1.28 1.28 0 01.28-.73.879.879 0 01.68-.29.86.86 0 01.68.26z",
        clipRule: "evenodd"
      }
    )
  );
};
export default H2;
